// ======================
// Accordion
// ======================
export default class Accordion {
    constructor(selector = '.js-accordion') {
        this.accordions = document.querySelectorAll(selector);
        if (this.accordions.length === 0) return;

        this.init();
    }

    init() {
        this.accordions.forEach(accordion => this.setupAccordion(accordion));
    }

    setupAccordion(accordion) {
        const content = accordion.querySelector('.js-accordion__content');
        if (!content) return;

        content.style.overflow = 'hidden';
        content.style.maxHeight = accordion.hasAttribute('open')
            ? content.scrollHeight + 'px'
            : '0';

        accordion.addEventListener('toggle', () => {
            if (accordion.open) {
                content.style.maxHeight = content.scrollHeight + 'px';
                content.style.opacity = '1';
            } else {
                content.style.maxHeight = '0';
                content.style.opacity = '0';
            }
        });
    }
}